<template>
    <div class="group-avatar">
		<image-avatar v-if="type == 'image'" v-bind="$props" v-on="$listeners" :style="imageAvatarStyles" />
        <letter-avatar v-if="type == 'letter'" v-bind="$props" v-on="$listeners" :style="letterAvatarStyles" />
	</div>
</template>


<script>
    import _ from 'lodash';

	export default {
		name: 'group-avatar',
        props: {
            name: {
				type: String,
				default: null
            },
            size: {
                type: [Number, String],
                default: 40
            },
            src: {
                type: String
            },
            styles: {
                type: Object,
                default() {
                    return {};
                }
            },
            title: {
                type: String,
                default: null
            },
            value: {
                type: String,
                default: null
            },
            color: {
				type: String,
				default: null
            },
            backgroundColor: {
                type: String,
                default: null
            },
            transparent: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            type() {
                if (this.src) return 'image';
                return 'letter';
            },
            imageAvatarStyles() {
                const defaults = {};

                if (this.backgroundColor && !this.transparent) defaults['background-color'] = this.backgroundColor;

                return defaults;
            },
            letterAvatarStyles() {
                const defaults = {};

                if (this.backgroundColor) defaults['background-color'] = this.backgroundColor;
                if (this.color) defaults['color'] = this.color;

                const result = _.extend(defaults, this.styles);

                return result;
            }
        }
	};
</script>


<style lang="scss">
.group-avatar {
    overflow: hidden;
}
</style>
